import React from 'react';
import styles from '../../../assets/styles/globals.scss';

function TrashIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path fill={props.fillColor || styles.offBlack} fillRule="nonzero" d="M15.36 18.24h-.96V9.6h.96v8.64zM24 3.84v.96h-2.88v18a1.2 1.2 0 0 1-1.2 1.2H4.08a1.2 1.2 0 0 1-1.2-1.2v-18H0v-.96h7.68V1.2A1.2 1.2 0 0 1 8.88 0h6.24a1.2 1.2 0 0 1 1.2 1.2v2.64H24zm-15.36 0h6.72V1.2a.238.238 0 0 0-.24-.24H8.88a.238.238 0 0 0-.24.24v2.64zm11.52.96H3.84v18c0 .134.106.24.24.24h15.84c.134 0 .24-.106.24-.24v-18zM9.6 9.6h-.96v8.64h.96V9.6z"/>
    </svg>

  );
}

export default TrashIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/TrashIcon/index.js